import React, { Component } from "react";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class ModalCEE extends Component {
  render() {
    return (
      <>
        <div>
         {/*  <fieldset className="panel"> */}
            {/* <legend>Certificado de exportación</legend> */}
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
               
          <div id="detalleCertificado">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_cer.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_cer.tipo_certificado}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_cer.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud_cer.fecha_solicitud!=null?this.props.state.solicitud_cer.fecha_solicitud.split("-").join("-").replaceAll("-","/"):this.props.state.solicitud_cer.fecha_solicitud}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">      
                
              <fieldset className="col-md-12">
                <legend>Datos generales</legend>

                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Nombre del producto</label>
                    <div className="form-control">
                      {this.props.state.certificado.nombre_comercial}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Tipo de producto</label>
                    <div className="form-control">
                      {this.props.state.certificado.tipo_producto}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>No. Registro sanitario</label>
                    <div className="form-control">
                      {this.props.state.certificado.no_registro}
                    </div>
                  </div>

                  <div className={this.props.state.certificado.clasificacion == null ? "hide" : "form-group col-md-6"} >
                    <label>Clasificación</label>
                    <div className="form-control">
                      {this.props.state.certificado.clasificacion}
                    </div>
                  </div>

                  <div className={this.props.state.certificado.condiciones_venta == null ? "hide" : "form-group col-md-6"} >
                    <label>Condiciones de venta</label>
                    <div className="form-control">
                      {this.props.state.certificado.condiciones_venta}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Titular</label>
                    <div className="form-control">
                      {this.props.state.certificado.titular_nombre}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Dirección titular</label>
                    <div className="form-control">
                      {this.props.state.certificado.direccion_establecimiento}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Fabricante</label>
                    <div className="form-control">
                      {this.props.state.certificado.fabricante.razon_social}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Dirección fabricante</label>
                    <div className="form-control">
                      {this.props.state.certificado.fabricante.direccion}
                    </div>
                  </div>
                  <div className="form-group col-md-4">
                    <label>País origen</label>
                    <div className="form-control">
                      {this.props.state.certificado.fabricante.pais_texto == null ? "NICARAGUA" : this.props.state.certificado.fabricante.pais_texto}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Fecha de registro</label>
                    <div className="form-control">
                      {this.props.state.certificado.fecha_registro}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Vencimiento del registro</label>
                    <div className="form-control">
                      {this.props.state.certificado.vigencia_registro}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>País destino</label>
                    <div className="form-control">
                      {this.props.state.certificado.pais}
                    </div>
                  </div>
                  <div className="form-group col-md-4">
                    <label>Caducidad del producto</label>
                    <div className="form-control">
                      {this.props.state.certificado.caducidad_producto}
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>Tiempo</label>
                    <div className="form-control">
                      {this.props.state.certificado.medida_tiempo}
                    </div>
                  </div>

                  <div className={this.props.state.certificado.uso?"form-group col-md-12":"hide"}>
                    <label>Uso</label>
                    <div className="form-control">
                      {this.props.state.certificado.uso === null?"N/A":this.props.state.certificado.uso}
                    </div>
                  </div>

                  <div className={this.props.state.certificado.precauciones_almacenamiento?"form-group col-md-12":"hide"}>
                    <label>Precauciones y condiciones de almacenamiento</label>
                    <div className="form-control">
                      {this.props.state.certificado.precauciones_almacenamiento}
                    </div>
                  </div>

                  <div className={this.props.state.certificado.precauciones_generales?"form-group col-md-12":"hide"}>
                    <label>Precauciones y condiciones de almacenamiento</label>
                    <div className="form-control">
                      {this.props.state.certificado.precauciones_generales}
                    </div>
                  </div>

                  <div className={this.props.state.certificado.precauciones_uso?"form-group col-md-12":"hide"}>
                    <label>Precauciones de uso</label>
                    <div className="form-control">
                      {this.props.state.certificado.precauciones_uso}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>{this.props.state.certificado.tipo_producto === "Alimento" ? "Forma de comercialización" : "Forma farmacéutica"}</label>
                    <div className="form-control">
                      {this.props.state.certificado.forma_farmaceutica}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Petición</label>
                    <div className="form-control">
                      {this.props.state.certificado.peticion}
                    </div>
                  </div>

                </div>
              </fieldset>
 {/* Lista principios activos */}
              <fieldset className={this.props.state.certificado.lista_principios_activos.length>0?"col-md-12":"col-md-12 hide"}>
            <legend>Principio activo: </legend>
              <div >
                    <div id="listaPrincipiosActivos" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Principio activo</th>
                            <th>Concentración</th>
                            <th>Unidad de medida</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_principios_activos.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.principio_activo_name}</td>
                              <td>{reg.concentracion}</td>
                              <td>{reg.unidad_medida_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>

            {/* Lista Excipientes */}
            <fieldset className={this.props.state.certificado.lista_excipiente.length>0?"col-md-12":"col-md-12 hide"}>
            <legend>Excipiente: </legend>
              <div >
                    <div id="listaPrincipiosActivos" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Excipiente</th>
                            <th>Concentración</th>
                            <th>Unidad de medida</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_excipiente.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.excipiente_name}</td>
                              <td>{reg.concentracion}</td>
                              <td>{reg.unidad_medida_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>


            
              {/* Lista composicion biologica */}
              <fieldset className={
                      this.props.state.certificado.lista_composiciones_biologicas.length > 0
                      ? "col-md-12"
                      : "col-md-12 hide"
                    }>
                  <div>
                    <div id="listaComposicionBiologica" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Composición biológica</th>
                            <th>Titulo/Unidad de medida</th>
                          
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_composiciones_biologicas.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.composicion_biologica_name}</td>
                                <td>{reg.titulo_unidad_medida}</td>
                                
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>

            {/* Lista composicion quimica */}
              <fieldset
                    className={
                      this.props.state.certificado.lista_composiciones_quimicas.length > 0 
                      ? "col-md-12"
                      : "col-md-12 hide"
                    }>
                    <div id="listaComposicionQuimica" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Composición química</th>
                            <th>Concentración</th>
                            <th>Unidad medida</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_composiciones_quimicas.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.composicion_quimica_name}</td>
                                <td>{reg.concentracion}</td>
                                <td>{reg.unidad_medida_name}</td>
                              
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                  </div>
              </fieldset>

              <fieldset className={
                    this.props.state.certificado.lista_analisis.length > 0 ? "col-md-12": "col-md-12 hide" }  >
            {/* Lista ANALISIS GARANTIZADO */}
            <legend>Análisis garantizado: </legend>
            <div>
                    <div id="listaAnalisis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Análisis garantizado</th>
                            <th>Porcentaje(%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_analisis.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.analisis_name}</td>
                              <td>{reg.porcentaje}</td>
                            
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>
              {/*  */}
              <fieldset 
                    className={
                      this.props.state.certificado.lista_especie_dosis.length > 0 
                        ? "col-md-12"
                        : "col-md-12 hide"
                    }>
                  {/* Lista dosis */}
                  <legend>Dosis por especie: </legend>
                  <div >
                    <div id="listaDosis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Dosis</th>
                            <th>Especie</th>
                            <th>Categoría</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_especie_dosis.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.dosis}</td>
                              <td>{reg.especie_name}</td>
                              <td>{reg.categoria_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>
              {/*  */}
              <fieldset className={
                      this.props.state.certificado.lista_empaque.length > 0 
                        ? "col-md-12"
                        : "col-md-12 hide"
                    }>
                       {/* Lista empaques */}
                       <legend>Presentaciones: </legend>
                       <div>
                    
                  
                    <div id="listaEmpaques" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Empaque</th>
                           {/*  <th>Presentaciones</th> */}
                            <th>Presentación cantidad</th>
                            <th>Unidad de medida</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_empaque.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.empaque_name}</td>
                              {/* <td>{reg.presentacion}</td> */}
                              <td>{reg.presentacion_cantidad}</td>
                              <td>{reg.presentacion_unidad_medida_name}</td>
                              
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>
              {/*  */}
              <fieldset className={
                      this.props.state.certificado.lista_presentaciones.length > 0 
                        ? "col-md-12"
                        : "col-md-12 hide"
                    }>
                       {/* Lista empaques */}
                       <legend>Presentaciones: </legend>
                       <div>
                    
                  
                    <div id="listaPresentacion" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                  
                           {/*  <th>Presentaciones</th> */}
                            <th>Presentación cantidad</th>
                            <th>Unidad de medida</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_presentaciones.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                           
                              <td>{reg.presentacion_cantidad}</td>
                              <td>{reg.presentacion_unidad_medida_name}</td>
                              
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>
              {/*  */}
              <fieldset className={
                      this.props.state.certificado.lista_descarte.length > 0
                        ? "col-md-12"
                        : "col-md-12 hide"
                    }>
                   {/* Lista descarte */}
                   <legend>Periodo de descarte: </legend>
                   <div>
                    
                    <div id="listaDescartes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Periodo</th>
                            <th>Tiempo</th>
                            <th>Especie producto</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.certificado.lista_descarte.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.periodo}</td>
                              <td>{reg.medida_tiempo_name}</td>
                              <td>{reg.especie_prod_name}</td>
                              
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
              </fieldset>
              {/*  */}
                
                <fieldset className={
                          this.props.state.certificado.representantes_legales.length > 0
                            ? "col-md-12"
                            : "col-md-12 hide"
                        }>
                      {/*  LISTA REPRESENTANTE LEGAL */}
                      <legend>Representantes legales: </legend>
                      <div >
                     
                      <div
                        id="listaRepresentantes" className="col-md-12">
                      
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Nombre completo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.certificado.representantes_legales.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.nombres+" "+reg.apellido_paterno+" "+reg.apellido_materno}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                 
                </fieldset>
              
              {/*<hr />
               <fieldset className="col-md-12">
                <legend>Documentación</legend>
                <div className="table-responsive">
                  <button
                    className="btn btn-primary pull-right"
                    onClick={this.handleDownloadZipCertificados}
                  >
                    Descargar selección
                  </button>
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th width="50">
                          <div className="checkbox checkbox-inline checkbox-css">
                            <input
                              onChange={this.allDocsCertificado}
                              type="checkbox"
                              value={this.state.allCc || false}
                              name="allc"
                              checked={this.state.allCc || false}
                              id="allc"
                            />
                            <label htmlFor="allc">Todos</label>
                          </div>
                        </th>
                        <th className="text-center">Vista previa</th>
                        <th className="text-center">Documento</th>
                        <th className="text-center">Fecha carga</th>
                        <th className="text-center">Estado</th>
                        <th className="text-center">Fecha aprobación</th>
                        <th className="text-center">Acción</th>
                      </tr>
                    </thead>
                    <tbody className={this.state.working ? "hide" : "show"}>
                      {this.state.certificado.documentos.map((reg) => (
                        <tr key={reg.id}>
                          <td className="text-center">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                type="checkbox"
                                id={reg.id}
                                onChange={this.handleCertificadoChecks}
                                name={reg.id}
                                value={
                                  this.state.certificadoDocsCheck[reg.id] || false
                                }
                                checked={
                                  this.state.certificadoDocsCheck[reg.id] || false
                                }
                              />
                              <label htmlFor={reg.id}></label>
                            </div>
                          </td>
                          <td className="text-center">
                            <img
                              alt="Vista previa"
                              className="rounded btn"
                              data-file={
                                Api.url + `app/documento/?id=${reg.id}`
                              }
                              onClick={this.handlePrevia}
                              width="60"
                              src={
                                Api.url + `app/documento/?id=${reg.id}&thumb=1`
                              }
                            />
                          </td>
                          <td className="text-center">{reg.documento}</td>
                          <td className="text-center">{reg.fecha_subida!==null?reg.fecha_subida.split(" ")[0].split("-").reverse().join("-").replaceAll("-","/"):""}</td>
                          <td className="text-center reg-doc-status">{reg.estatus}</td>
                          <td className="text-center">{reg.fecha_aprueba_sinaip!==null?reg.fecha_aprueba_sinaip.split("-").reverse().join("-").replaceAll("-","/"):""}</td>
                          <td className="text-center">
                            <div className="btn-group">
                              <a
                                href={
                                  Api.url +
                                  `app/documento/?id=${reg.id}&download=1`
                                }
                                className="btn btn-primary"
                              >
                                <i className="fas fa-file-download"></i>
                              </a>
                              <button
                                className="btn btn-danger"
                                data-solicitud_id={reg.solicitud_id}
                                data-solicitud_estatus={reg.estatus}
                                id={reg.id}
                                onClick={this.handleRegentDocumentStatus}
                                data-toggle="tooltip"
                                data-placement="top"
                                data-name="Rechazar"
                                disabled={reg.aprobado !== "1" ? true : false}
                              >
                                <i className="fas fa-ban"
                                  data-solicitud_id={reg.solicitud_id}
                                  data-solicitud_estatus={reg.estatus}
                                  id={reg.id}
                                  onClick={this.handleRegentDocumentStatus}
                                  data-name="Rechazar"
                                  disabled={reg.aprobado !== "1" ? true : false}
                                ></i>
                                Rechazar
                              </button>
                              <button
                                className="btn btn-success"
                                data-solicitud_id={reg.solicitud_id}
                                data-solicitud_estatus={reg.estatus}
                                id={reg.id}
                                onClick={this.handleRegentDocumentStatus}
                                data-toggle="tooltip"
                                data-placement="top"
                                data-name="Aprobar"
                                disabled={reg.aprobado !== "1" ? true : false}
                              >
                                <i className="fas fa-check"
                                 data-solicitud_id={reg.solicitud_id}
                                 data-solicitud_estatus={reg.estatus}
                                 id={reg.id}
                                 onClick={this.handleRegentDocumentStatus}
                                 data-name="Aprobar"
                                 disabled={reg.aprobado !== "1" ? true : false}
                                ></i>
                                Aprobar
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </fieldset> */}
              <hr />{}
              <div className="col-md-12">
                <fieldset className="panel">
                  <legend>
                    Justificación
                    <span className="text-danger"> *</span>{" "}
                  </legend>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="justificacion"
                      value={this.props.state.certificado.justificacion}
                      disabled={true}
                    ></textarea>
              </fieldset>
              </div>
              
              <hr></hr>
              <div className="col-md-12">
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.props.component.handleCertificadoStatus}
                    value="4"
                    id="rechazar_cer"
                    className="btn btn-danger"
                    disabled={this.props.state.certificado.aprobado==="5" || this.props.state.certificado.aprobado==="4"? true: false}
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
               {/*    <button id="regresar_mv" className="btn btn-white ">
                    Regresar
                  </button> */}
                  <button
                    onClick={this.props.component.handleCertificadoStatus}
                    value="5"
                    id="aprobar_cer"
                    className="btn btn-success"
                    disabled={this.props.state.certificado.aprobado==="5" || this.props.state.certificado.aprobado==="4"? true: false}
                  >
                    Aceptar
                  </button>
                </div>
              </div>

              </div>
              </div>
              </div>
              </div>
              </div>{/* 
              </fieldset> */}
              </div>
      </>
    );
  }
}

export default ModalCEE;
